import type { ReadonlyRecord } from '../../../utils'

export const extractDataTestId = (props: ReadonlyRecord<never, unknown>, appendage?: string | null): string | null => {
    const testId = ('data-testid' in props && typeof props['data-testid'] === 'string' && props['data-testid']) || null

    if (testId && appendage) {
        return testId + appendage
    }

    return testId
}
